<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>My Hometown</span></h1>
<p class="P_Normal__And__Left_Indent">By SJD Peterson</p>
<p class="P_Normal__And__Left_Indent"> </p>
<p class="P_Normal">Jimmy Brink and Eric Halter grew up together in a small country town. While Eric has always been content with life as a rancher, Jimmy wanted more and moved to Chicago early on to pursue a medical career.</p>
<p class="P_Normal">Life has a way of coming back around. When Jimmy’s parents decide to retire in Florida, Jimmy returns to his hometown to finish his residency at a local hospital. Flamboyant boyfriend Oliver in tow, Jimmy bumps into his old friend. Eric quickly takes a disliking to Oliver, though, and for good reason. Oliver proves he’s not only self-centered but also a cheater.</p>
<p class="P_Normal">When Jimmy finds out, he sends Oliver packing, not knowing Oliver is vengeful and maybe even teetering toward insane. Soon Jimmy and Eric are fighting to take back their hometown, while Eric finds it more and more difficult to hide his attraction to his best friend.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?7a1db959